export class VideoExtractApplicationService {
    constructor(videoExtractRepository, interfaceGateway, randomGateway) {
        this.videoExtractRepository = videoExtractRepository;
        this.interfaceGateway = interfaceGateway;
        this.randomGateway = randomGateway;
    }
    removeVideoExtractOnInterface() {
        return Promise.all([
            this.interfaceGateway.changeVideoExtract(undefined),
            this.interfaceGateway.unMuteMusic()
        ])
            .then(() => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    applyVideoExtractOnInterface(cleavage, fullRandom) {
        if (fullRandom)
            return this.onFullRandom();
        const majorChoice = cleavage.majorChoice();
        return majorChoice
            ? this.onMajorChoice(majorChoice, cleavage)
            : this.onNoMajorChoice();
    }
    onFullRandom() {
        return this.videoExtractRepository.retreiveAllExtracts()
            .then(extracts => Promise.all([
            extracts,
            this.randomGateway.randomIntegerOnRange(1, extracts.length)
        ]))
            .then(([extracts, randomChoice]) => {
            const index = randomChoice - 1;
            const extract = extracts.at(index);
            return extract
                ? this.playVideo(extract)
                : Promise.reject(new Error(noVideoAtIndex(index)));
        });
    }
    onMajorChoice(majorChoice, cleavage) {
        return this.videoExtractRepository.retreiveVideoExtractsByChoice(majorChoice)
            .then(videoExtracts => this.playVideo(this.videoExtractWithClosestMajorChoiceScore(videoExtracts, cleavage)))
            .catch(error => Promise.reject(error));
    }
    videoExtractWithClosestMajorChoiceScore(videoExtracts, cleavage) {
        return videoExtracts.reduce((a, b) => Math.abs(b.percentage - cleavage.majorScore()) < Math.abs(a.percentage - cleavage.majorScore()) ? b : a);
    }
    playVideo(videoExtract) {
        return Promise.all([
            this.interfaceGateway.changeVideoExtract(videoExtract),
            this.interfaceGateway.muteMusic()
        ])
            .then(() => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    onNoMajorChoice() {
        return this.videoExtractRepository.retreiveEqualityVideoExtracts()
            .then(videoExtracts => Promise.all([
            videoExtracts,
            this.randomGateway.randomIntegerOnRange(1, videoExtracts.length)
        ]))
            .then(([videoExtracts, randomVideoNumber]) => {
            const index = randomVideoNumber - 1;
            const videoExtract = videoExtracts.at(index);
            return videoExtract
                ? this.playVideo(videoExtract)
                : Promise.reject(new Error(noVideoAtIndex(index)));
        })
            .catch(error => Promise.reject(error));
    }
    hasVideoExtractForChoice(choice) {
        return choice
            ? this.videoExtractRepository.hasVideoExtract(choice)
            : this.videoExtractRepository.hasEqualityVideoExtract();
    }
}
const noVideoAtIndex = (index) => `There is no video extract at index ${index}.`;
